import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import classNames from 'volta/helpers/class-names';
import BvText from 'volta/components/bv-text';

import type { TOC } from '@ember/component/template-only';
import type { ComponentLike, ContentValue } from '@glint/template';

interface BvChoiceLabelSignature {
  Args: {
    disabled?: boolean;
    id?: string;
    label?: ContentValue | ComponentLike;
    labelClass?: string;
    labelHidden?: boolean;
    onClick: (e: MouseEvent) => void;
    onMouseOut: (e: MouseEvent) => void;
    onMouseOver: (e: MouseEvent) => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLabelElement;
}

const BvChoiceLabelComponent: TOC<BvChoiceLabelSignature> = <template>
  <label
    class={{classNames
      'bv-choice'
      (if @labelHidden 'bv-choice--label-hidden')
      (if @disabled 'bv-choice--disabled')
    }}
    for={{@id}}
    data-test-choice-label='{{@label}}'
    ...attributes
    {{on 'click' (optional @onClick)}}
    {{on 'mouseover' (optional @onMouseOver)}}
    {{on 'mouseout' (optional @onMouseOut)}}
  >
    <span class='bv-choice__control'>
      {{yield}}
    </span>
    <BvText class={{classNames 'bv-choice__label' @labelClass}}>
      {{! @glint-expect-error: Only primitive values and certain DOM objects (see ContentValue in glint/template) are usable as top-level template content.}}
      {{@label}}
    </BvText>
  </label>
</template>;

export default BvChoiceLabelComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvChoice::Label': typeof BvChoiceLabelComponent;
    'bv-choice/label': typeof BvChoiceLabelComponent;
  }
}
